import { render } from "./PlacementZoneDimensions.vue?vue&type=template&id=7354dfb4&scoped=true"
import script from "./PlacementZoneDimensions.vue?vue&type=script&lang=js"
export * from "./PlacementZoneDimensions.vue?vue&type=script&lang=js"

import "./PlacementZoneDimensions.vue?vue&type=style&index=0&id=7354dfb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7354dfb4"]])

export default __exports__